module.exports = {
  BannerSplinter: 'Banner',
  BannerSplinterEditable: 'Banner',
  CardEditable: 'Card',
  CarouselEditable: 'Carousel',
  GridEditable: 'Grid',
  SubtitleEditable: 'Subtitle',
};
